export const color = {
     black:  "#111212",
     white:  "#FFFFFF",
     grey:    "#333333",
     gradient:  "linear-gradient(180deg, rgba(0, 0, 0, 0.27) 0%, rgba(28, 28, 28, 0.72) 50.41%, #333333 94.81%)",
     red:"#FFADBA"

}
